import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import {Redirect, withRouter} from 'react-router-dom';
import {WithChangeLocale} from 'containers/LanguageProvider/WithChangeLocale';
import {InstructionLayout} from 'components/layout/InstructionLayout';
import {WithValidateSignupToken} from 'api/users/WithValidateSignupToken';
import {ALVA_SELECTED_ORGANIZATION_KEY} from 'services/auth/constants';
import ValidateToken from './pages/ValidateToken';
import ActivateAccount from './pages/ActivateAccount';
import {SignupInstructions} from './components/SignupInstructions';
import AdditionalConsents from './pages/AdditionalConsents';
import AdditionalConsentsInstructions from './components/AdditionalConsentsInstructions';

const SUCCESS_REDIRECT = '/login';


class SignupContainer extends React.Component {

    static propTypes = {
        location: PropTypes.shape({
            search: PropTypes.string
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func
        }).isRequired,
        displayToast: PropTypes.func
    };

    constructor(props) {
        super(props);

        const params = queryString.parse(this.props.location.search);

        this.state = {
            token: params['t'],
            tokenValidated: false,
            accountActivated: false,
            userData: null,
            additionalConsentsCompleted: false
        };
    }

    componentDidMount() {
        localStorage.removeItem(ALVA_SELECTED_ORGANIZATION_KEY);
    }

    onUserAccountActivated = () => {
        this.setState({accountActivated: true});
    };

    onTokenValidated = (localLocale, changeLocale, userData) => {
        if (userData.language !== localLocale) {
            changeLocale(userData.language);
        }
        this.setState({tokenValidated: true, userData});
    };

    renderValidateToken = () => {
        return (
            <WithChangeLocale>
                {({locale, changeLocale}) => (
                    <WithValidateSignupToken>
                        {({validateSignupToken, loading, error}) => (
                            <ValidateToken
                                validateToken={validateSignupToken}
                                loading={loading}
                                error={error}
                                onValidToken={userData => this.onTokenValidated(locale, changeLocale, userData)}
                                token={this.state.token}
                            />
                        )}
                    </WithValidateSignupToken>
                )}
            </WithChangeLocale>
        );
    };

    onAdditionalConsentsCompleted = () => {

        this.setState({additionalConsentsCompleted: true});
    };

    renderContent = () => {
        if (!this.state.tokenValidated) {
            return this.renderValidateToken();
        }

        if (!this.state.accountActivated) {
            return <ActivateAccount
                token={this.state.token}
                onUserAccountActivated={this.onUserAccountActivated}
                email={this.state.userData.email}
                firstName={this.state.userData.firstName}
                lastName={this.state.userData.lastName}/>;
        }

        if (!this.state.additionalConsentsCompleted) {
            return <AdditionalConsents
                token={this.state.token}
                onCompleted={this.onAdditionalConsentsCompleted}/>;
        }

        return <Redirect to={SUCCESS_REDIRECT}/>;
    };

    renderInstructions = () => {
        if (!this.state.tokenValidated) {
            return <div/>;
        }

        if (!this.state.accountActivated) {
            return <SignupInstructions/>;
        }

        if (!this.state.additionalConsentsCompleted) {
            return <AdditionalConsentsInstructions/>;
        }

        return <div/>;

    };

    render() {
        return (
            <InstructionLayout instruction={this.renderInstructions()}>
                <ContentWrapper>
                    {this.renderContent()}
                </ContentWrapper>
            </InstructionLayout>
        );
    }
}

const ContentWrapper = styled.div`
  margin-top: 20vh;

  @media only screen and (max-width: 768px) {
    margin-top: 84px;
  }
`;


export default withRouter(SignupContainer);
